@media (max-width: 600px) {
    .login-link-pretext {
        display: none;
    }
}

.main-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 24px;
}

.nutshell-logo {
    width: 160px;
    height: 24px;
    aspect-ratio: 160/24;
}

.login-link {
    color: var(--report-segment-dark-blue, #065289);
}
